import { render } from "./PanelAgendaSurveysEdit.vue?vue&type=template&id=356b065b"
import script from "./PanelAgendaSurveysEdit.vue?vue&type=script&lang=js"
export * from "./PanelAgendaSurveysEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__